import React from 'react';
import classNames from 'classnames';
import './index.scss';

type IconWrapperProps = {
  children: React.ReactNode;
  className?: string;
};

export const IconWrapper: React.FC<IconWrapperProps> = ({ children, className }) => (
  <div className={classNames('icon-wrapper', { [className as string]: className })}>{children}</div>
);
